import { render, staticRenderFns } from "./SortColumn.vue?vue&type=template&id=917626ee&lang=pug"
import script from "./SortColumn.vue?vue&type=script&lang=js"
export * from "./SortColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports